<template>
  <div class="a-input">
    <input
      ref="input"
      v-model="inputValue"
      :type="type"
      class="a-input__body"
      :name="name"
      :class="[errorInvalidClassName]"
      :placeholder="placeholder"
      :maxlength="maxLength"
      @blur="blurUpdateValidateError"
    />
    <span
      v-if="visiblePassword"
      class="a-input__switch"
      @click="switchVisiblePassword"
      >{{ passwordBody }}</span
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    matchValue: {
      type: String,
      required: false,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    validateRule: {
      type: RegExp,
      required: false,
      default: new RegExp('')
    },
    validateMode: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      default: 2000
    },
    visiblePassword: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validateError: false,
      passwordBody: '表示'
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value: string) {
        if (this.validateMode === 'input') {
          this.validate(this.validateRule, value);
          this.$emit('validateInput', this.validateError);
        }
        this.$emit('input', value);
      }
    },
    errorInvalidClassName() {
      return this.validateError ? 'a-input__body--error' : '';
    }
  },
  methods: {
    validate(validateRule: string, value: string) {
      if (!value.match(new RegExp(validateRule))) {
        this.validateError = true;
      } else if (this.matchValue !== undefined && value !== this.matchValue) {
        this.validateError = true;
      } else {
        this.validateError = false;
      }
    },
    blurUpdateValidateError() {
      if (this.validateMode === 'blur') {
        this.validate(this.validateRule, this.inputValue);
        this.$emit('validateBlur', this.validateError);
      } else if (this.validateMode === 'input') {
        this.validate(this.validateRule, this.inputValue);
        this.$emit('validateInput', this.validateError);
      }
    },
    switchVisiblePassword() {
      const $input = this.$refs.input;
      const type = $input.getAttribute('type');
      switch (type) {
        case 'text':
          $input.setAttribute('type', 'password');
          this.passwordBody = '表示';
          break;

        case 'password':
          $input.setAttribute('type', 'text');
          this.passwordBody = '非表示';
          break;

        default:
          $input.setAttribute('type', 'password');
          this.passwordBody = '表示';
          break;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.a-input {
  position: relative;

  &__body {
    width: 100%;
    padding: 13px 16px;
    background: #f1f4f6;
    border: 1px solid #f1f4f6;
    border-radius: 8px;
    color: #484848;
    outline: none;
    appearance: none;

    &::placeholder {
      color: $gray-scale-color-40;
    }

    &--error {
      border-color: #ff6a6a;
    }
  }

  &__switch {
    position: absolute;
    top: 14px;
    right: 14px;
    max-width: fit-content;
    font-size: 14px;
    color: #0071bc;
    cursor: pointer;
  }
}
</style>
